module.exports = __webpack_public_path__ + "static/media/vision-mision-background.9a39617f.png";